module.exports = __webpack_public_path__ + "img/ywAward-a.87dac3b7.png";